import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { TagGroupsApiService, Tags } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { debounce, filter, map, of, switchMap, tap, timer } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssetTagsService {
  private tagName!: string;
  tags?: string[];

  constructor(private tagGroupsApiService: TagGroupsApiService) {}

  fetchTagsForAutoComp(updateAssetForm: AbstractControl<AnyType, AnyType> | null, tagsInfo?: Tags[]) {
    return updateAssetForm?.valueChanges.pipe(
      debounce(() => timer(500)),
      filter((value) => typeof value === 'string'),
      tap((value) => (this.tagName = value)),
      map((value) => ({ value, filterObj: this.createFilterObj({ name: { $regex: `${value}`, $options: 'i' } }) })),
      switchMap((filterObject) => {
        if (filterObject.value !== '') {
          return this.tagGroupsApiService.tagGroupsControllerFindGroupsNTags(JSON.stringify(filterObject.filterObj));
        } else {
          return of([]);
        }
      }),
      map((value) => value.filter((res) => !tagsInfo?.some((tag) => tag._id === res._id) && !this.tags?.some((tag) => tag === res.name))),
    );
  }

  createFilterObj(nameObj: AnyType) {
    const filterObject: AnyType = {};
    filterObject['filters'] = { ...nameObj };
    filterObject['projection'] = { name: 1 };
    return filterObject;
  }

  updateTagsArray(tags: string[]) {
    this.tags = tags;
  }

  accessTagName() {
    return this.tagName;
  }
}
